import './form.scss';

import { PropsWithChildren } from 'react';

type FormRowProps = PropsWithChildren<{
  className?: string;
  width?: string;
}>;

export function FormRow({ className, width, children }: FormRowProps) {
  return (
    <div
      className={`form-row${className ? ` form-row--${className}` : ``}`}
      style={{ flex: `0 0 ${width}`, maxWidth: width }}
    >
      {children}
    </div>
  );
}

type FormSectionProps = PropsWithChildren<{
  className?: string;
  title?: JSX.Element | string;
  description?: JSX.Element | string;
}>;

export function FormSection({
  className,
  description,
  title,
  children,
}: FormSectionProps) {
  return (
    <div
      className={`form-section${
        className ? ` form-section--${className}` : ``
      }`}
    >
      {title && <h3>{title}</h3>}
      {description && <p className="info">{description}</p>}
      {children}
    </div>
  );
}

type FormColumnsProps = PropsWithChildren<{
  className?: string;
}>;

export function FormColumns({ className, children }: FormColumnsProps) {
  return (
    <div
      className={`form-columns${
        className ? ` form-columns--${className}` : ``
      }`}
    >
      {children}
    </div>
  );
}

type FormLabelProps = PropsWithChildren;

export function FormLabel({ children }: FormLabelProps) {
  // eslint-disable-next-line jsx-a11y/label-has-associated-control
  return <label>{children}</label>;
}
